import * as React from 'react';
import { StandardTextField } from '@jeremyling/react-material-ui-form-builder';
import NumberFormat from 'react-number-format';
import { TextField } from '@mui/material';
import { Title } from './widgets/Title';

const omitUndefined = obj =>
    Object.keys(obj).reduce((acc, key) => {
        if (obj[key] === undefined) {
            return acc;
        }
        acc[key] = obj[key];
        return acc;
    }, {});

const NumberFormatCustom = React.forwardRef((props, ref) => {
    const { onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={ref}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
        />
    );
});

const NumericField = (field, methods, f) => {
    const {
        control,
        getValues,
        setValue,
        trigger,
        reset,
        formState: { errors },
    } = methods;

    const fieldConfig = field;

    const [numberformat, setNumberformat] = React.useState();
    const {
        allowedDecimalSeparators,
        decimalScale,
        fixedDecimalScale,
        decimalSeparator,
        prefix,
        suffix,
        thousandsGroupStyle,
        format,
        allowEmptyFormatting,
        mask,
        allowNegative,
        ...restProps
    } = fieldConfig.props;

    const numericInputProps = omitUndefined({
        allowedDecimalSeparators,
        decimalScale,
        fixedDecimalScale,
        decimalSeparator,
        prefix,
        suffix,
        thousandsGroupStyle,
        format,
        allowEmptyFormatting,
        mask,
        allowNegative,
    });

    React.useEffect(() => {
        if (!f?.value && typeof f?.value === 'object') {
            reset(formValues => ({
                ...formValues,
                [fieldConfig?.attribute]: '',
            }));
        }
    }, [f, fieldConfig]);

    const handleChange = event => {
        f.onChange(event);
    };

    const componentProps = (fieldConfig, field) => {
        return {
            id: fieldConfig.id || fieldConfig.attribute,
            fullWidth: true,
            label: fieldConfig.label,
            error: fieldConfig.attribute in errors,
            helperText: errors[fieldConfig.attribute]?.message,
            onKeyDown: event => {
                // if (event.key === 'Enter') {
                //     trigger(fieldConfig.attribute);
                // }
            },
            value: field.value || '',
            onChange: handleChange,
            ...restProps,
            InputProps: {
                inputComponent: NumberFormatCustom,
                inputProps: {
                    ...numericInputProps,
                },
            },
        };
    };
    const props = componentProps(fieldConfig, f);
    return (
        <>
            {fieldConfig.title && <Title field={fieldConfig} />}
            <TextField {...props} methods={methods} />
        </>
    );
};

export default NumericField;
